
import { FC, useEffect, useState } from "react";
import { useAppSelector } from "../../../app/hooks";
import MailXtraSmallIcon from "@ht/shared/fonts/deos-pis/mail-outline-extra-small";
import PlusIcon from "@ht/shared/fonts/deos-pis/plus";
import { colors } from "@ht/shared/theme/index";
import { Button, ScrollBar, Select } from "@ht/components";
import { useHttpRequest } from "../../../hooks/useHttpRequest";
import SlideModal from "../../../components/slide-modal";
import { SearchBox } from "../../../components/search-box";
import Spinner from "../../../components/spinner";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../../../utils/encryption";
import CircularProgress from "../../../components/circular-progress";
import { MessageBox } from "../../../components/message-box";
import { nanoid } from "nanoid";

interface IProps {
    visible: boolean,
    onClose(custid?: string): void
}
interface ICustomerGroup {
    letter: string,
    customers: ICustomerContact[];
}
interface ICustomerContact {
    id: string,
    fullname: string,
    email: string[],
    phone_number: string[]
}
const ContactSearchSlideModal: FC<IProps> = ({ visible, onClose }) => {
    const customerBaseUrl = String(process.env.REACT_APP_CUSTOMER_SERVICE);
    const chatBaseUrl = String(process.env.REACT_APP_CHAT_SERVICE);
    const navigate = useNavigate();
    const { user } = useAppSelector(state => state.auth);
    const { sendRequest: getRequestChanelApp } = useHttpRequest(chatBaseUrl);
    const { sendRequest, loading, progress, setProgress } = useHttpRequest(chatBaseUrl);
    const { sendRequest: getRequestCustomer, loading: loadingRequestCustomer } = useHttpRequest(customerBaseUrl);
    const [searchKeyword, setSearchKeyword] = useState("")
    const [customerData, setCustomerData] = useState<Array<ICustomerContact>>([])
    const [contactList, setContactList] = useState<Array<ICustomerGroup>>()
    const [channelAccounts, setChannelAccounts] = useState<Array<{ label: string, value: string }>>([]);
    const [channelAccount, setChannelAccount] = useState<any>();
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [message, setMessage] = useState("");
    const closeMessageBoxHandler = () => {
        setShowMessageBox((prev) => !prev);
        setMessage("");
    };
    function compare(a: any, b: any) {
        if (a.letter < b.letter) {
            return -1;
        }
        if (a.letter > b.letter) {
            return 1;
        }
        return 0;
    }
    const groupByLetter = (arr: ICustomerContact[]) => {
        const data: any[] = []
        if (arr.length > 0)
            return arr.reduce((store, itm) => {
                const letter = itm.fullname.charAt(0)
                const isExist = data.filter((x) => x.letter == letter)
                if (isExist.length < 1) {
                    const cust = []
                    cust.push(itm)
                    data.push({ letter, customers: cust })
                }
                else
                    data.filter((x) => x.letter === letter)[0].customers.push(itm)

                return data.sort(compare)

            }, {})
        return []
    }
    const retrieveData = async () => {
        const dt = await getRequestCustomer({
            url: `/customer-list/${user?.tenantId}?src=${searchKeyword}`,
            method: "get",
        });

        if (dt?.data) {
            setCustomerData(dt.data as any);
        }
    }
    const retrieveChannelAccount = async () => {
        const dt = await getRequestChanelApp({
            url: `/chat/ChannelApplication`,
            method: "get",
            params: { tenantid: user?.tenantId }
        });

        if (dt?.data.length > 0) {
            const options = dt.data.map(a => {
                return { label: a.name, value: a.id, ...a };
            })
            setChannelAccounts(options.filter(a => a.channel_id == "EMAIL"));
        }
    }
    const channelAccountHandler = (event: any) => {
        setChannelAccount(event);
    }
    const newSessionHandler = async (email: string) => {
        if (channelAccount == undefined) {
            setShowMessageBox(true);
            setMessage("Please choose channel account");
            return;
        } else if (email == undefined || email == "" || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
            setShowMessageBox(true);
            setMessage("Please invalid email!");
            return;
        }
        const body = {
            userName: email,
            fullName: email,
            serviceGroupId: channelAccount.service_group_id,
            tag: "generic",
            agentUserName: user?.username,
            tenantId: user?.tenantId,
            channel: channelAccount.channel_id,
            channelApplicationId: channelAccount.id
        }
        const result = await sendRequest({
            url: '/chat/JoinRoomAll',
            method: "post",
            body
        });
        if (result) {
            if (result.message.includes('Success'))
                navigate(`/messages/${encrypt(email)}`)
            else {
                setShowMessageBox(true);
                setMessage(result.message);
            }
        }
    }
    useEffect(() => {
        const ct = groupByLetter(customerData.filter(a => a.email.length > 0)) as ICustomerGroup[]
        setContactList(ct)
    }, [customerData])

    useEffect(() => {
        retrieveData().catch((e) => console.log(e))
    }, [visible])

    useEffect(() => {
        if (user)
            retrieveChannelAccount().catch((e) => console.log(e))
    }, [user])
    const renderEmailList = (cust: ICustomerContact, indexCust: any, index: any) => {
        return cust.email.map((mail, x) => {
            const emailstring = (mail ?? "").replace(/^(.)([^@]*)(@.*)$/, (_, a: string, b: string, c: string) => a + b.replace(/./g, '*') + c)
            return (
                <div key={`mail${cust.id}${index}a${indexCust}b${x}`} className="flex flex-row justify-between items-center gap-1 pr-3">
                    <div className="flex gap-1">
                        <MailXtraSmallIcon className="text-gray-300 w-[16px] h-[16px]" />
                        <span>{emailstring}</span>
                    </div>
                    <PlusIcon className="cursor-pointer" onClick={() => newSessionHandler(mail)} />
                </div>
            )
        })
    }
    const getCustomerList = (item: ICustomerGroup, index: number) => {
        return item.customers.map((cust, indexCust) => {
            return (
                <div key={`cust${index}a${indexCust}`} className="flex flex-row justify-start items-start gap-[8px] w-full hover:bg-gray-200 mx-[4px]">
                    <div className="rounded-full bg-gray-200 w-[36px] h-[36px] mt-2 ml-2">

                    </div>
                    <div className="flex flex-col justify-start flex-1 gap-[4px] border-b border-1 border-gray-100 pb-[12px]">
                        <div className="text-md text-black font-semibold w-full text-left">
                            {cust.fullname}
                        </div>
                        <div className="flex flex-row gap-[12px]">
                            <div className="flex flex-col gap-[8px] flex-1">
                                {renderEmailList(cust, indexCust, index)}
                            </div>
                        </div>

                    </div>
                </div>
            )
        })
    }
    return (
        <>
            {loading && <CircularProgress loading={loading} progress={progress} setProgress={setProgress} />}
            <MessageBox type="warning" visible={showMessageBox} closeHandler={closeMessageBoxHandler} title="Warning" message={message} />
            <SlideModal title="Customer Contact" className=" md:h-[96vh] h-[90vh] xxsToXs:w-[97%] xsToSm:w-[97%] top-0" visible={visible}
                onClose={() => {
                    onClose();
                }} >
                {visible && <div className="flex flex-col  gap-2 h-full">
                    <div className="text-gray-700 flex flex-col gap-1">
                        <Select
                            name="channelAccount"
                            onChange={channelAccountHandler}
                            placeholder="Choose Channel Account"
                            bgColor={colors.gray["100"]}
                            options={channelAccounts}
                            value={channelAccount}
                            showBorder={false}
                        />
                    </div>
                    <div className="flex gap-1">
                        <div className="flex-1">
                            <SearchBox name="searchContact"
                                placeHolder="Type partial name and press enter"
                                onChange={(e) => {
                                    setSearchKeyword(e.target.value)
                                }}
                                onEnter={() => {
                                    console.log("loading data...", searchKeyword)
                                    retrieveData().catch((e) => console.log(e))
                                }}
                                isDisabled={loadingRequestCustomer}
                            />
                        </div>
                        <Button color="primary" onClick={() => newSessionHandler(searchKeyword)} className="rounded h-8 !hover:bg-primary" >
                            <PlusIcon className="cursor-pointer" />
                        </Button>
                    </div>
                    {loadingRequestCustomer ?
                        <div className="sm:w-[430px] h-full flex items-center justify-center">
                            <Spinner loading={loadingRequestCustomer} position="FULL_PARENT" type="PUFF"></Spinner>
                        </div> :
                        <ScrollBar className="sm:w-[430px]"
                            initialView="top"
                            bottom="150px">
                            <div className="flex flex-col gap-[8px] pt-[8px] pb-[8px]">
                                {contactList?.map((item, index) => {
                                    const uuid = nanoid(12);
                                    return (<div key={`ctc${uuid}`}>
                                        <div className="text-lg font-bold">
                                            {item.letter}
                                        </div>
                                        <div className="flex flex-col">
                                            {getCustomerList(item, index)}
                                        </div>
                                    </div>
                                    )
                                })}

                            </div>
                        </ScrollBar>}
                </div>}
            </SlideModal>
        </>
    );
}

export default ContactSearchSlideModal;